import apiUrl from '../../../constants'
import axios from 'axios'
import { ModelSelect } from 'vue-search-select';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import BagCloseDetails from './BagCloseDetails/index.vue';
import BagInShipmentLiveResponse from './BagInShipmentLiveResponse/index.vue';
import PushShipmentDataNew from './pushShipmentDataNew/index.vue';
import HubInscanLogs from './hubInscanLogs/index.vue';


export default {
	name: 'FalconSorter',
	components: {
		DatePicker,
		ModelSelect,
		'first': BagCloseDetails,
		'second':HubInscanLogs,
		'third': BagInShipmentLiveResponse,
		'fourth':PushShipmentDataNew

	},
	props: [],
	data() {
		return {
			hubLoading:'',
			hubid:"",
			hubdetailsarray:[],
			HubNameData:[],
			DestHubNameData:[],
			ARMSTRONG_API_KEY:'',
			isEnable:false,
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
					key: 'First',
					value: 'Bag Close Details'
				},
				{
					key: 'Second',
					value: 'Hub Inscan Logs'
				},
				{
					key: 'third',
					value: 'BagIn Shipment Live Response'
				},
				{
					key: 'fourth',
					value: 'Push Shipment Data New System'
				}
			],
		}
	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {
		this.getHubName();
	},
	methods: {
		getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getSorterHubDetails?vendorName=FALCON',
          // 'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          this.hubdetailsarray = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].sorterhubid,
              text: HubNameData[i].sorterhubname + ' (' + HubNameData[i].sorterhubid + ')'
            })
            this.HubNameData = this.DestHubNameData
          }
        }, error => {
					this.hubLoading = ''
          console.error(error)
        })
    }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/FalconSorter/FalconSorter.js